//const MAX_MEMORY_LIMIT = 200 * 1048576; // 200MB
const MAX_PERCENT_THRESHOLD = 90;


class MemoryChecker {
    constructor() {
        this.isEnabled = (!window.performance || !window.performance.memory) ? false : true;
        this.hasAlarmed = false;
        this.value = 0;
    }

    check() {
        if (!this.isEnabled) { return; }
        this.value = performance.memory.usedJSHeapSize;
        // Check if we have exceeded absolute memory limit
        //if (this.value > MAX_MEMORY_LIMIT) {
        //    this.hasAlarmed = true;
        //}

        // Check if we have exceeded relative memory limit for client
        if (this.value > (MAX_PERCENT_THRESHOLD / 100) * performance.memory.jsHeapSizeLimit) {
            this.hasAlarmed = true;
            console.log("Memory usage exceeded " + MAX_PERCENT_THRESHOLD + "% of maximum: " + performance.memory.jsHeapSizeLimit);
        }
    }
};

export { MemoryChecker };